<template>
  <v-layout wrap pa-3>    
    <v-flex sm12 pr-2>
        <v-switch v-model="debugEnable" label="Debug actif"  />
    </v-flex>
    <v-flex sm12 pr-2>
      <v-text-field clearable v-model="debugFilterSearch" :label="$t('Admin.Debug.Search')" append-icon="mdi-magnify" />                
    </v-flex>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import {FilterBase} from '@/models/filter/FilterBase'

@Component({
  name: 'DebugFilter',   
   props: {       
     itemTypeName:String
  }
})
export default class DebugFilter extends Vue {  
  itemTypeName!:string

  get debugFilterSearch() {    
    //@ts-ignore
    return this.$store.myGetters.debugFilter.search
  }
  set debugFilterSearch(value) {
    //@ts-ignore
    this.$store.myActions.DEBUG_UPDATE_FILTER({search:value == null?"":value})
  } 

  get debugEnable(){
    return this.$store.myGetters.debugEnable
  }
  set debugEnable(newValue) {
    this.$store.myActions.DEBUG_TOGGLE_STATE()
  }
}
</script>